import { useTeamOnboardingEligibilityQuery } from '@trello/graphql/generated';
import { useFeatureFlag } from '@trello/feature-flag-client';
import moment from 'moment';
import Cookies from 'js-cookie';
import { isMemberAdmin } from '@trello/organizations';

const startDate = moment('2020-05-15');

// TODO add router condition to only return true if users
// last url was /getting-started
export const useTeamOnboarding = (orgId: string = '') => {
  const isFlagEnabled = useFeatureFlag('btg.bc-team-onboarding', false);
  const { loading, data } = useTeamOnboardingEligibilityQuery({
    variables: { orgNameOrId: orgId },
    skip: !orgId || !isFlagEnabled,
  });

  const organization = data?.organization;
  const member = data?.member;
  const products = organization?.products || [];
  const messagesDismissed = member?.oneTimeMessagesDismissed || [];
  const dateFirstSubscription =
    organization?.paidAccount?.dateFirstSubscription;
  const isEnterprise = member?.idEnterprise;
  const isOrgAdmin =
    !!member && !!organization && isMemberAdmin(member, organization);

  return {
    isLoading: loading,
    isEligible:
      isFlagEnabled &&
      !messagesDismissed.includes(`bc-onboarding-pup-popover:${orgId}`) &&
      !isEnterprise &&
      products.length > 0 &&
      isOrgAdmin &&
      ((dateFirstSubscription &&
        moment(dateFirstSubscription).isAfter(startDate)) ||
        Cookies.get('simulateNewOrg')),
  };
};
